import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import { checkTelPhone } from '@/shared/utils/validator';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'CompanyPhone' })
export default class CompanyPhone extends Vue implements InfoComplementField {
  @Prop()
  private value!: string;

  /** 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
  */
  @Prop()
  private validator: ((value: string, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private companyPhone = '';

  private errorMsg = '';

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  public onValidator(): boolean {
    const val = this.companyPhone;
    if (typeof this.validator === 'function') {
      return this.validator(val, this.setErrorMsg.bind(this));
    }

    if (!checkTelPhone(val)) {
      this.errorMsg = '请输入正确的公司电话';
      return false;
    }
    return true;
  }

  private created() {
    if (this.value) {
      this.companyPhone = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: string) {
    if (val !== this.companyPhone) {
      this.companyPhone = val;
    }
  }

  private onChangeTelNumber(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onBlur() {
    this.$emit('blur');
  }

  private render() {
    return (
      <div class={style.CompanyPhone}>
        <Field
          v-model={this.companyPhone}
          class="border"
          sub={true}
          type="text"
          label="公司电话"
          placeholder="请输入公司电话"
          onChange={this.onChangeTelNumber.bind(this)}
          error={this.errorMsg}
          onBlur={this.onBlur.bind(this)}
        />
      </div>
    );
  }
}
